import { Component, OnInit, Input, Output, ViewChild, EventEmitter, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';

import * as CryptoJS from 'crypto-js';

import { ProjectsService } from '../../services/projects.service';
import { AlertManagerService } from '../../../../shared/services/alert-manager.service';
import { CookieManagerService } from '../../../../shared/services/cookie-manager.service';

import { WorkConstants } from "../../work.const";
import { Sprint, Task } from '../../../models';
import { Attachment } from '../../../models/attachment';
import { CreatedBy } from '../../../models/created-by';

declare var $: any

@Component({
  selector: 'app-task-view',
  templateUrl: './task-view.component.html'
})
export class TaskViewComponent implements OnInit {

  @Input() projectId: number;
  @Input() issueId: number;
  @Input() sprintId: number;
  @Input() formData: any = [];
  @Output() getBacklogData: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('attachFile') attachFile: any;
  @ViewChild('editAttachFile') editAttachFile: any;
  @ViewChild('taskModal') elementRef: ElementRef;
  @ViewChild('taskViewModal') elementRef2: ElementRef;

  emitNumber: number;

  taskForm: FormGroup;
  task: Task = new Task();
  temTask: Task;
  currentfile: any;
  subTask: any;
  users: Array<any>;
  sprints: Array<Sprint>;
  attachDescription: string;
  editAttachDescription: string;
  backlogType: string;
  isSubmitted: boolean = false;
  isCreate: boolean = true;
  isDisabledFile: boolean = false;
  isDisabledEditFile: boolean = false;
  isSprints: boolean = false;
  isRemove: boolean = false;
  currentDate: string;
  authUser: any = {};

  isCommentEditor: Array<boolean> = [];
  isDeleteConfirm: Array<boolean> = [];
  isView: boolean = false;
  trasparent: boolean = false;
  attachment: Attachment = new Attachment();

  workConstants: any = WorkConstants;

  constructor(
    private formBuilder: FormBuilder,
    private alertService: AlertManagerService,
    private projectsService: ProjectsService,
    private cookieManagerService: CookieManagerService
  ) {

  }

  ngOnInit() {
    this.initTaskForm();
    this.currentDate = new Date().toString();
    this.attachment.created_by = new CreatedBy();
    let $this = this;
    $(this.elementRef.nativeElement).on('hidden.bs.modal', function (e) {
      $this.resetForm();
    });
  }

  ngAfterViewInit() {
    // prevent Bootstrap from hijacking TinyMCE modal focus 
    $(document).on('focusin', function (e) {
      if ($(e.target).closest(".mce-window").length) {
        e.stopImmediatePropagation();
      }
    });
  }

  onChangeStory(event) {
    if (!this.isSprints) {
      if (event) {
        let story = this.formData.stories.filter(story => { return story.id === parseInt(event); });
        this.temTask = Object.assign({}, this.task);
        this.task.sprint_id = story[0].sprint_id;
        this.taskForm.controls['sprint_id'].disable();
      } else {
        this.task = this.temTask ? Object.assign({}, this.temTask) : this.task;
        this.taskForm.controls['sprint_id'].enable();
      }
    }
  }

  onOpenModalForIssue(projectId, task?) {
    if (task) {
      this.projectId = projectId;
      this.getFormdata(projectId, task);
    } else {
      this.projectId = projectId;
      this.getFormdata(projectId);
    }
  }

  /**
   * change modal size
   * loaded all sprints
   */
  onOpenModal(task?: Task, storyId?: number, i?: number, emitNumber?: number, view?: boolean) {
    if (task) {
      if (view) {
        this.isView = true;
      } else {
        this.isView = false;
      }
      this.getTask(task.id, true);
      this.isCreate = false;
    } else {
      this.isCreate = true;
      this.taskForm.controls['sprint_id'].enable();
      this.taskForm.controls['parent_id'].enable();
      $(this.elementRef.nativeElement).modal({ backdrop: 'static', keyboard: false })
      $(this.elementRef.nativeElement).modal('show');
    }
    this.emitNumber = emitNumber;
    this.setIsSprints();
    this.setSubTask(storyId, i);
    this.getAuthUser();
  }

  /**
   * set sprint id or not 
   */
  setIsSprints() {
    if (this.sprintId < 0) {
      this.isSprints = false;
    } else {
      this.isSprints = true;
      this.task.sprint_id = this.sprintId;
      this.taskForm.controls['sprint_id'].disable();
    }
  }

  setSubTask(storyId, i) {
    this.subTask = null;
    if (storyId) {
      this.subTask = {
        id: storyId,
        i: i
      }
    }
  }

  getAuthUser() {
    let userToken = this.cookieManagerService.getCookie(WorkConstants.basicConstans.userToken, false);
    this.authUser = JSON.parse(CryptoJS.AES.decrypt(userToken, WorkConstants.basicConstans.userKey).toString(CryptoJS.enc.Utf8));
  }

  getFileExtintion(fileName): string {
    let file = fileName.split('.');
    let extintion = file[file.length - 1]
    return extintion;
  }

  /**
   * set task form group
   */
  initTaskForm() {
    this.taskForm = this.formBuilder.group({
      title: ['', Validators.required],
      estimate_time: [],
      effort_time_left: [],
      assignee: [],
      status: [],
      sprint_id: [],
      attachDescription: [],
      editAttachDescription: [],
      parent_id: [],
      description: [],
      acc_criteria: [],
    });
  }

  /**
   * clean all field in task form
   */
  resetForm() {
    // this.taskForm.reset();
    ((this.attachFile || {}).nativeElement || {}).value = "";
    this.currentfile = null;
    this.isDisabledFile = false;
    this.trasparent = false;
    this.isSubmitted = false;
    this.isCommentEditor = [];
    this.isDeleteConfirm = [];
    this.temTask = null;
    this.task = new Task();
  }

  /**
   * created task edit object for edit task
   * return {Task}
   */
  createEditObject(): Task {
    let editTask = new Task();
    editTask.title = this.task.title;
    editTask.estimate_time = this.task.estimate_time;
    editTask.assignee_id = this.task.assignee_id;
    editTask.status = this.task.status;
    editTask.sprint_id = this.task.sprint_id;
    editTask.description = this.task.description;
    editTask.parent_id = this.task.parent_id;
    editTask.effort_time_left = this.task.effort_time_left;
    editTask.acc_criteria = this.task.acc_criteria;

    editTask.attachments = new Array<Attachment>();

    if (this.currentfile || this.attachDescription) {
      let attachment = new Attachment();
      attachment.path = this.currentfile ? this.currentfile.fileName : "";
      attachment.description = this.attachDescription;
      editTask.attachments[0] = attachment;
    }

    return editTask;
  }

  setAttachmentForCreateObject() {
    if (this.issueId) {
      this.task.bug_id = this.issueId;
    }
    if (this.currentfile) {
      this.task.attachments = new Array<Attachment>();
      let attachment = new Attachment();
      attachment.path = this.currentfile.fileName;
      attachment.description = this.attachDescription;
      this.task.attachments[0] = attachment;
    }
  }

  openEditCommentForm(id?, attachment?) {
    if (attachment) {
      this.trasparent = true;
      this.isCommentEditor[attachment.id] = true;
    } else {
      this.trasparent = false;
      this.isCommentEditor[id] = false;
      this.getTask(this.task.id, false);
    }
  }

  openDeleteConfirmFrom(attachment) {
    this.trasparent = true;
    this.isDeleteConfirm[attachment.id] = true;
  }

  doConfirmeDelete(event, attachment) {
    if (event) {
      this.deleteTaskAttachment(attachment.id);
    }
    this.trasparent = false;
    this.isDeleteConfirm[attachment.id] = false;
  }

  /**
   * do submit story
   * create or edit selection
   */
  doCreateTask() {
    this.isSubmitted = true;
    if (this.taskForm.valid) {
      if (this.isCreate) {
        this.createTask();
      } else {
        this.editTask();
      }
    }
  }

  /**
   * create story
   */
  createTask() {
    this.setAttachmentForCreateObject();
    this.projectsService.createTask(this.projectId, this.task).subscribe(
      res => {
        this.resetForm();
        if (this.emitNumber) {
          this.getBacklogData.emit(this.emitNumber);
        } else {
          this.getBacklogData.emit(this.subTask);
        }
        $(this.elementRef.nativeElement).modal('hide');
        this.alertService.success({ title: "SUCCESS", msg: "Successfully Created" });
      },
      error => {
        this.resetForm();
        $(this.elementRef.nativeElement).modal('hide');
      }
    )
  }

  /**
   * edit story
   */
  editTask() {
    this.projectsService.editTask(this.task, this.createEditObject()).subscribe(
      success => {
        this.attachFile.nativeElement.value = "";
        this.attachDescription = "";
        this.currentfile = null;
        this.isDisabledFile = false;
        this.getTask(this.task.id, false);
        if (this.emitNumber) {
          this.getBacklogData.emit(this.emitNumber);
        } else {
          this.getBacklogData.emit(this.subTask);
        }
        this.alertService.success({ title: "SUCCESS", msg: "Successfully Updated" });
      }
    );
  }

  editTaskAttachment(attachment: any) {
    let body = new Attachment;
    body.path = attachment.path;
    body.description = attachment.description;
    this.projectsService.editTaskAttachment(attachment.id, this.task.id, body).subscribe(
      res => {
        this.isCommentEditor[attachment.id] = false;
        this.trasparent = false;
        this.isRemove = false;
        this.isDisabledEditFile = false;
        this.getTask(this.task.id, false);
        this.alertService.success({ title: "SUCCESS", msg: "Attachment Updated Successfully" });
      }
    );
  }

  deleteTaskAttachment(attachmentId: number) {
    this.projectsService.deleteTaskAttachment(attachmentId).subscribe(
      res => {
        this.getTask(this.task.id, false);
        this.alertService.success({ title: "SUCCESS", msg: "Attachment Deleted Successfully" });
      }
    );
  }

  /**
   * upload file for story
   */
  fileChanged(event) {
    this.projectsService.uploadFile(event.target.files[0]).subscribe(
      file => {
        this.currentfile = file.data;
        this.isDisabledFile = true;
      }
    );
  }

  editFileChanged(event) {
    this.projectsService.uploadFile(event.target.files[0]).subscribe(
      file => {
        this.attachment.path = file.data.fileName;
        this.isDisabledEditFile = true;
      }
    );
  }

  /**
   * remove upload file
   */
  removeFile() {
    this.projectsService.removeFile(this.currentfile.fileName).subscribe(
      file => {
        this.currentfile = null;
        this.isDisabledFile = false;
        this.attachFile.nativeElement.value = "";
      }
    );
  }

  removeEditFile() {
    this.projectsService.removeFile(this.attachment.path).subscribe(
      file => {
        this.attachment.path = null;
        this.isDisabledEditFile = false;
        this.editAttachFile.nativeElement.value = "";
      }
    );
  }

  /**
   * get task details by task id
   */
  getTask(taskId, isShow) {
    this.projectsService.getTask(taskId).subscribe(
      task => {
        this.task = task;
        if (isShow) {
          if (this.task.parent_id) {
            this.taskForm.controls['sprint_id'].disable();
            this.taskForm.controls['parent_id'].disable();
          } else {
            this.taskForm.controls['sprint_id'].enable();
            this.taskForm.controls['parent_id'].enable();
          }
          $(this.elementRef.nativeElement).modal({ backdrop: 'static', keyboard: false })
          $(this.elementRef.nativeElement).modal('show');
        }
      }
    );
  }

  /**
   * get all form data
   */
  getFormdata(projectId, task?) {
    this.projectsService.getTaskFormData(projectId, 3).subscribe(
      formData => {
        this.formData = formData.data;
        task ? this.onOpenModal(task) : this.onOpenModal();
      }, error => {
        // this.loginAgainService.isOpen(true);
        console.log(error);
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/work/modal/modal-task/task-view.component.ts